const getTimeZoneOffset = (timeZoneId, timezones = []) => {
    return timezones.find(t => t.id === timeZoneId)?.timeZone ?? null;
}

export default getTimeZoneOffset;